import { useEffect, useState } from 'react';


const useToggleStylesheet = (isDark) =>
{
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() =>
  {
    setIsLoaded(true);

    document.documentElement.setAttribute(
      'data-bs-theme',
      isDark ? 'dark' : 'light'
    );

    document.getElementsByTagName('html')[0].setAttribute('dir', 'ltr');
  }, [isDark]);

  return { isLoaded };
};

export default useToggleStylesheet;
